/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ExtractionMethod } from './ExtractionMethod.js';
import {
    ExtractionMethodFromJSON,
    ExtractionMethodFromJSONTyped,
    ExtractionMethodToJSON,
} from './ExtractionMethod.js';
import type { ParticipantRole } from './ParticipantRole.js';
import {
    ParticipantRoleFromJSON,
    ParticipantRoleFromJSONTyped,
    ParticipantRoleToJSON,
} from './ParticipantRole.js';

/**
 * 
 * @export
 * @interface CreateExtractorRequest
 */
export interface CreateExtractorRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateExtractorRequest
     */
    label?: string;
    /**
     * 
     * @type {ExtractionMethod}
     * @memberof CreateExtractorRequest
     */
    method?: ExtractionMethod;
    /**
     * 
     * @type {ParticipantRole}
     * @memberof CreateExtractorRequest
     */
    role?: ParticipantRole;
    /**
     * 
     * @type {number}
     * @memberof CreateExtractorRequest
     */
    threshold?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateExtractorRequest
     */
    options?: string;
}

/**
 * Check if a given object implements the CreateExtractorRequest interface.
 */
export function instanceOfCreateExtractorRequest(value: object): boolean {
    return true;
}

export function CreateExtractorRequestFromJSON(json: any): CreateExtractorRequest {
    return CreateExtractorRequestFromJSONTyped(json, false);
}

export function CreateExtractorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExtractorRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'method': json['method'] == null ? undefined : ExtractionMethodFromJSON(json['method']),
        'role': json['role'] == null ? undefined : ParticipantRoleFromJSON(json['role']),
        'threshold': json['threshold'] == null ? undefined : json['threshold'],
        'options': json['options'] == null ? undefined : json['options'],
    };
}

export function CreateExtractorRequestToJSON(value?: CreateExtractorRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'method': ExtractionMethodToJSON(value['method']),
        'role': ParticipantRoleToJSON(value['role']),
        'threshold': value['threshold'],
        'options': value['options'],
    };
}

